import React from "react"
import styled from "styled-components"

import MouseIcon from "../../assets/icons/MouseIcon"
import HandCursorIcon from "../../assets/icons/HandCursorIcon"

const ScrollButton = ({ onClick, label, textColor, iconColor }) => {
  return (
    <Button onClick={onClick}>
      <HandIconWrapper>
        <HandCursorIcon fill={iconColor} />
      </HandIconWrapper>
      <MouseIconWrapper>
        <MouseIcon fill={iconColor} />
      </MouseIconWrapper>
      <Label color={textColor}>{label}</Label>
    </Button>
  )
}

export default ScrollButton

const HandIconWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    display: none;
  }
`

const MouseIconWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    display: block;
  }
`

const Button = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0 10px;
`

const Label = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary_font};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.025em;
  color: ${({ color, theme }) =>
    color ? color : theme.colors.secondary_color};

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    font-size: 14px;
  }
`
